import { styled } from 'styled-components'
import { onLargeScreen, onMediumScreen } from 'mixtiles-web-common'
import { TOP_BAR_DESKTOP_HEIGHT } from 'elements/TopBar/consts'
import {
  DESKTOP_HERO_ROW_GAP,
  LARGE_SCREEN_HERO_HEIGHT,
  MEDIUM_SCREEN_HERO_HEIGHT,
  PHOTO_WALLS_VIDEO_ASPECT_RATIO,
} from './multiProductHomePage.consts'

// Design: at least this much of the next row always shows below Photo Walls without scrolling.
const NEXT_ROW_MIN_VISIBLE_HEIGHT = 40
const PHOTO_WALLS_MAX_HEIGHT = `calc(100svh - ${TOP_BAR_DESKTOP_HEIGHT}px - ${DESKTOP_HERO_ROW_GAP}px - ${NEXT_ROW_MIN_VISIBLE_HEIGHT}px)`

export const Container = styled.div`
  width: 100%;
  background: ${({ theme }) => theme.colors.white};

  box-sizing: border-box;
  * {
    box-sizing: border-box;
  }
`

export const VideosContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;

  ${onMediumScreen()} {
    display: grid;
    /* A hero's min-height turns into a min-width through its aspect-ratio; minmax(0, …) keeps the halves equal. */
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: ${DESKTOP_HERO_ROW_GAP}px;

    > :first-child,
    > :last-child:nth-child(2) {
      grid-column: 1 / -1;
    }

    /* Photo Walls shows its whole video, at least at Figma's height, but never pushes the next row out of view. */
    > :first-child {
      aspect-ratio: ${PHOTO_WALLS_VIDEO_ASPECT_RATIO};
      min-height: min(
        ${MEDIUM_SCREEN_HERO_HEIGHT}px,
        ${PHOTO_WALLS_MAX_HEIGHT}
      );
      max-height: ${PHOTO_WALLS_MAX_HEIGHT};
    }
  }

  ${onLargeScreen()} {
    > :first-child {
      min-height: min(${LARGE_SCREEN_HERO_HEIGHT}px, ${PHOTO_WALLS_MAX_HEIGHT});
    }
  }
`

export const FooterContainer = styled.div`
  ${onMediumScreen()} {
    /* The shared footer needs ~790px: pad 40px at 800 → 120px at 1280 and clip the rest, like the regular homepage. */
    padding-inline: clamp(40px, calc((100% - 560px) / 6), 160px);
    overflow-x: clip;
    background-color: ${({ theme }) => theme.colors.grayBackgroundWhite};
  }
`
